import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router';
import { SpeakerDetailsConsumer } from '../../contexts/SpeakerDetailsContext';
import ProgramCard from '../Program/components/ProgramCard';
import './SpeakerDetails.scss';

export const SpeakerDetails = ({ isLoading, speakers, talks, loadSpeakerDetails }) => {
  const history = useHistory();
  const { speakerId } = useParams();
  const details = speakers.find(sp => sp.id === speakerId) || {};
  const filteredTalks = talks.filter(talk => talk.speakers.includes(speakerId));

  useEffect(() => {
    loadSpeakerDetails(speakerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="speaker-details-section">
      <section className="section sp-form" id="speaker-details">
        <div className="container sp-container">
          {!isLoading && !speakers.some(sp => sp.id === speakerId) ? (
            <h4 className="title is-4">Oops ! There is no such speaker.</h4>
          ) : (
            <div className="card">
              <div className="columns is-centered">
                {isLoading ? (
                  <i className="fa fa-spinner fa-spin fa-3x fa-fw" style={{ color: '#7500c0' }} />
                ) : (
                  <div className="column is-four-fifths is-10-mobile is-offset-1-mobile">
                    <div className="underline">
                      <div className="info">
                        <div className="speaker-photo">
                          <img
                            alt="speaker"
                            className="img"
                            onError={e => {
                              e.target.src = 'imgs/speakers/unknown.png';
                            }}
                            src={details.photo || 'imgs/speakers/unknown.png'}
                          />
                        </div>
                        <h4 className="title is-4" id="name">
                          {details.name}
                        </h4>
                        <p className="title is-6">{details.company}</p>
                        <p className="description">{details.longDesc}</p>
                      </div>
                    </div>

                    <div>
                      <h4 className="title is-4 talks-title">Talks</h4>
                      <div className="columns is-multiline">
                        {filteredTalks.map(talk => {
                          const speakerNames = [];
                          if (talk.speakers) {
                            talk.speakers.forEach(spId => {
                              const foundTalk = speakers.find(sp => sp.id === spId) || {};
                              const speakerName = foundTalk.name;
                              speakerNames.push(speakerName);
                            });
                          }

                          return (
                            <div key={talk.id} className="column is-6 is-12-touch">
                              <ProgramCard
                                color={`${talk.conferenceDay}-color`}
                                endTime={talk.endTime}
                                id={talk.id}
                                speakerNames={speakerNames}
                                startTime={talk.startTime}
                                talk={{ title: talk.title, youtube: talk.youtube }}
                                tileRole=""
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <button
                className="button is-large is-rounded btn-submit back-btn"
                onClick={() => history.goBack()}
                type="button">
                Back
              </button>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

SpeakerDetails.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  loadSpeakerDetails: PropTypes.func.isRequired,
  speakers: PropTypes.arrayOf(PropTypes.any).isRequired,
  talks: PropTypes.arrayOf(PropTypes.any).isRequired
};

const SpeakerDetailsContainer = props => (
  <SpeakerDetailsConsumer>
    {({ isLoading, speakers, talks, loadSpeakerDetails }) => (
      <SpeakerDetails
        isLoading={isLoading}
        loadSpeakerDetails={loadSpeakerDetails}
        speakers={speakers}
        talks={talks}
        {...props}
      />
    )}
  </SpeakerDetailsConsumer>
);

export default SpeakerDetailsContainer;
